import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const earliestYear = 1900;

export const isoDateValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) {
    return { isoDate: true };
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  const isRealDate = parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day;

  return isRealDate && year >= earliestYear ? null : { isoDate: true };
};
